<template>
  <div class="container-fluid">
    <div class="promo mx-auto">
      <div class="promo-content">
        <a :href="promoOne['url']" class="bordered-image small-poster">
          <lazy-image
            class="promo-content-small-poster"
            :alt="promoOne['title']"
            :title="promoOne['title']"
            :src="promoOne['poster']['small']"
          />
        </a>
        <a :href="promoTwo['url']" class="bordered-image d-none d-md-flex mb-5 tiny-poster">
          <lazy-image
            class="promo-content-tiny-poster"
            :alt="promoTwo['title']"
            :title="promoTwo['title']"
            :src="promoTwo['poster']['small']"
          />
        </a>
        <a :href="promoThree['url']" class="bordered-image small-poster">
          <lazy-image
            class="promo-content-small-poster"
            :alt="promoThree['title']"
            :title="promoThree['title']"
            :src="promoThree['poster']['small']"
          />
        </a>
      </div>
      <div class="promo-info">
        <div class="short-divider"></div>
        <h2 class="promo-info-title">
          {{ $t("body_promo.title") }}
        </h2>
        <p class="promo-info-description">
          {{ $t("body_promo.subtitle") }}
        </p>
        <router-link :to="$t('routes.register')" class="btn btn-danger">
          {{ $t("body_promo.button") }}
        </router-link>
      </div>
      <div class="promo-content-rogue">
        <a
          :href="rogueOne['url']"
          class="bordered-image promo-content-rogue-one d-flex"
        >
          <lazy-image
            :alt="rogueOne['title']"
            :title="rogueOne['title']"
            :src="rogueOne['poster']['small']"
          />
        </a>
        <a
          :href="rogueTwo['url']"
          class="bordered-image promo-content-rogue-two d-none d-md-flex"
        >
          <lazy-image
            :alt="rogueTwo['title']"
            :title="rogueTwo['title']"
            :src="rogueTwo['poster']['small']"
          />
        </a>
        <a
          :href="
            $router.resolve($t('routes.get_the_full_experience')).href +
            '?p=kids'
          "
          class="bordered-image promo-content-rogue-three d-flex"
        >
          <lazy-image alt="Pokoyo" title="Pokoyo" :src="'/img/pokoyo.png'" />
        </a>
        <a
          :href="rogueFour['url']"
          class="bordered-image promo-content-rogue-four d-flex"
        >
          <lazy-image
            :alt="rogueFour['title']"
            :title="rogueFour['title']"
            :src="rogueFour['poster']['small']"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from "@/components/utils/LaziImage.vue";
import { OrizonApiClient } from "@/services/OrizonApiClient";

const apiClient = new OrizonApiClient();
export default {
  props: {
    promoContent: {
      type: Object,
      required: false,
      default: () => {
        return {
          promoOne: "amor-prohibido",
          promoTwo: "love-for-rent",
          promoThree: "todos-mienten",
          rogueOne: "mediterraneo",
          rogueTwo: "el-embarcadero",
          rogueThree: "pokoyo",
          rogueFour: "nada-personal",
        };
      },
    },
  },
  data() {
    return {
      promoOne: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
      promoTwo: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
      promoThree: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
      rogueOne: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
      rogueTwo: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
      rogueThree: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
      rogueFour: {
        url: "",
        title: "",
        poster: {
          small: "",
        },
      },
    };
  },
  methods: {
    fetchAsset(asset) {
      if (this.loading) {
        return;
      }
      apiClient.get("/asset/" + this.promoContent[asset]).then((response) => {
        if (response.error === null) {
          this[asset] = response.data;
        }
      });
    },
  },
  beforeMount() {
    this.fetchAsset("promoOne");
    this.fetchAsset("promoTwo");
    this.fetchAsset("promoThree");
    this.fetchAsset("rogueOne");
    this.fetchAsset("rogueTwo");
    if (this.promoContent["rogueThree"] !== "pokoyo") {
      this.fetchAsset("rogueThree");
    }
    this.fetchAsset("rogueFour");
  },
  name: "BodyPromoUno",
  components: { LazyImage },
  computed: {},
};
</script>

<style lang="scss" scoped>
.webp {
  .short-divider {
    display: block;
    height: 1px;
    width: 200px;
    margin: 0.5em;
    background: url("@/assets/img/divider-short.webp") no-repeat center left;
  }
}
.short-divider {
  display: block;
  height: 1px;
  width: 200px;
  margin: 0.5em;
  background: url("@/assets/img/divider-short.png") no-repeat center left;
}
.btn {
  min-width: 225px;
  line-height: 50px;
  justify-content: center;
  font-size: 1.1em;
  border-radius: 16px;
  z-index: 9999;
}
.bordered-image {
  padding: 8px;
  border-radius: 1vw;
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(11, 16, 25, 0.3) 50%,
    rgba(46, 58, 80, 0.8) 100%
  );
}
.promo {
  //max-width: 1244px;
  //min-width: 400px;
  min-height: 742px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &-content {
    justify-content: space-between;
    align-items: flex-end;
    display: inherit;
    flex-direction: row;
    margin-bottom: 64px;
    margin-top: 64px;


    .bordered-image {
      img{
        width: 100%;
        height: auto;
        border-radius: 1vw;
      }
      &.small-poster{
        width: 37%;
        @media (min-width: 768px) {
          width: 32%;
        }
        @media (min-width: 1024px) {
          width: 27%;
        }
      }
      &.tiny-poster{
        width: 17%;
      }
    }
    @media (min-width: 1024px) {
      width: 60%;
    }




    @media (max-width: 480px) {
      width: 100%;
      justify-content: space-between;
      column-gap: 0;
      margin-bottom: 36px;
      margin-top: 36px;
    }
    &-rogue {
      justify-content: space-between;
      align-items: flex-end;
      display: inherit;
      flex-direction: row;
      margin-bottom: 64px;
      // min-height: 650px;

      @media (min-width: 1024px) {
        width: 60%;
        margin-top: -6rem;
      }

      @media (max-width: 480px) {
        width: 100%;
        justify-content: space-between;
        column-gap: 0;
        margin-top: 36px;
        min-height: 250px;
        margin-bottom: 0;
      }

      & > * > img {
        border-radius: 1vw;
        width: 100%;
        height: auto;
      }
      &-one {
        align-self: start;
        height: auto;
        width: 30%;
        @media (min-width: 768px) {
          width: 15%;
        }
      }
      &-two {
        align-self: start;
        width: 16%;
        height: auto;
        margin-top: 25%;
        margin-left: -21%;
      }
      &-three {
        align-self: start;
        height: auto;
        margin-top: 5%;
        width: 30%;
        @media (min-width: 480px) {
          margin-top: 18%;
          width: 15%;
        }
      }
      &-four {
        align-self: start;
        width: 30%;
        @media (min-width: 480px) {
          width: 25%;
          margin-top: 15%;
        }
      }
    }
    &-tiny-poster {
      // width: 156px;
      // height: 219px;
      // border-radius: 10px;
    }
    &-small-poster {
      // width: 254px;
      // height: 377px;
      // border-radius: 10px;
      // @media (max-width: 480px) {
      //   width: 132px;
      //   height: 185px;
      // }
    }
  }
  &-info {
    display: inherit;
    flex-direction: column;
    row-gap: 16px;
    max-width: 750px;
    align-items: center;
    justify-content: center;
    text-align: center;
    &-title {
      font-weight: 700;
      font-size: 4em;
      line-height: 1.1em;
      @media (max-width: 480px) {
        font-size: 2em;
        line-height: 40px;
      }
    }
    &-description {
      font-size: 1.2em;
      padding: 16px;
    }
  }


  @media (min-width: 1920px) {
    &-info {
      font-size: 0.8vw;
      width: 50%;
      max-width: none;
      
      &-description {
        max-width: 80%;
      }
    }
  }
}
</style>
